import { LogOut } from "lucide-react";
import { SiteFooter, SiteHeader } from "./BrandLogo";
import { useAuth } from "../context/AuthContext";

export const AppShell = ({ children }) => {
  const { user, logout } = useAuth();
  return (
    <div className="confetti-bg-white font-manrope min-h-screen text-slate-900">
      <SiteHeader logoTo="/dashboard">
        <div className="flex items-center gap-4">
          <span data-testid="header-user-email" className="hidden text-sm text-slate-500 sm:inline">{user?.email}</span>
          <button
            data-testid="logout-button"
            onClick={logout}
            className="inline-flex items-center gap-2 rounded-lg border border-slate-200 bg-white px-4 py-2 text-sm font-medium text-slate-700 shadow-sm transition-[background-color] duration-200 hover:bg-slate-50 active:scale-95"
          >
            <LogOut className="h-4 w-4" /> Log out
          </button>
        </div>
      </SiteHeader>
      <main className="mx-auto max-w-7xl px-5 py-10 sm:px-8 sm:py-14">{children}</main>
      <SiteFooter />
    </div>
  );
};
